import React from "react";

import {
    Form,
    FormElement,
    FormValidator,
    CustomTextControl,
    BaseReactComponent,
    FormSubmitButton,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { CustomModal, ImageUploader } from "../common";
import { addCategoryApi, addDimensionsApi, updateCategoryApi, updateDimensionsApi } from "./Api";
import { API_LIMIT, IMAGEFILETYPE, START_PAGE } from "../../utils/Constant";

class TemplateDimensionsForm extends BaseReactComponent {
    constructor(props) {
        super(props);
        const data = props.editData || null;

        this.state = {
            pageSize: API_LIMIT,
            currentPage: START_PAGE,
            dimensionName: data?.dimensionName || "",
            description: data?.description || "",
            dimension: data?.dimension
        };
    }

    componentDidMount() { }
    imageUploaser = (e, name) => {

        const imageUrl = URL.createObjectURL(e.target.files[0]);
        if (name === "banner") {
            this.setState({ bannerPath: e.target.files[0].name, bannerfile: e.target.files[0], uploadImage2: imageUrl })
        } else if (name === "circleImage") {
            this.setState({ circleImagePath: e.target.files[0].name, circleImageFile: e.target.files[0], uploadImage3: imageUrl })
        } else {
            this.setState({ thumbnailPath: e.target.files[0].name, thumbnailFile: e.target.files[0], uploadImage: imageUrl })
        }

    }

    onValidSubmit = () => {

        let detail = {
            "data": {
                "dimensionName": this.state.dimensionName,
                "description": this.state.description,
                "dimension": this.state.dimension

            }
        }
        if (this.props?.editData?.uuid) {
            updateDimensionsApi(detail, this.props.this, this.props.onHide, this.props.editData.uuid)
        } else {
            addDimensionsApi(detail, this.props.this, this.props.onHide);
        }
    };

    render() {
        const { uploadImage, thumbnailFile, bannerfile, uploadImage2, circleImageFile, uploadImage3 } = this.state;
        return (
            <CustomModal
                show={this.props.show}
                onHide={this.props.onHide}
                title={(this.props.editData?.uuid) ? "Edit Template Dimension" : "Add Template Dimension"}
                modalClass={"change-password"}
            >
                <Form onValidSubmit={this.onValidSubmit}>
                    <Row>
                        <Col sm={6}>
                            <FormElement
                                valueLink={this.linkState(this, "dimensionName")}
                                label="Name"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Field cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Name",
                                    },
                                }}
                            />
                        </Col>

                        <Col sm={6}>
                            <FormElement
                                valueLink={this.linkState(this, "dimension")}
                                label="Enter Dimension"
                                required
                                validations={[
                                    {
                                        validate: FormValidator.isRequired,
                                        message: "Field cannot be empty",
                                    },
                                ]}
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        placeholder: "Enter Dimension",
                                    },
                                }}
                            />
                        </Col>

                        <Col sm={12}>
                            <FormElement
                                valueLink={this.linkState(this, "description")}
                                label="Description"
                                helpText="Description can't be more than 4000 character"
                                control={{
                                    type: CustomTextControl,
                                    settings: {
                                        //   type: "",
                                        as: "textarea",
                                        placeholder: "Enter Description",
                                    },
                                }}
                            />
                        </Col>
                    </Row>
                    <div className="submit-wrapper" style={{ justifyContent: "center" }}>
                        <FormSubmitButton customClass={"primary-btn"}>
                            Save
                        </FormSubmitButton>
                    </div>
                </Form>
            </CustomModal>
        );
    }
}

export default TemplateDimensionsForm;
